import React, { Component } from 'react';
import {observer} from 'mobx-react';
import Sort from './Sort';
import {Desktop, LargeDesktop} from './Responsive';

@observer
class TableHeader extends Component {
    constructor(props) {
        super(props);
        this.setSort = this.setSort.bind(this);
    }

    setSort(sort) {
        if (this.props.appState.sort === sort) {
            let sortDirection = this.props.appState.sortDirection;
            let newDirection;

            switch (sortDirection) {
                case Sort.direction.ascending:
                    newDirection = Sort.direction.descending;
                    break;
                case Sort.direction.descending:
                    newDirection = Sort.direction.ascending;
                    break;
                default: break;
            }

            this.props.appState.sortDirection = newDirection;
        } else {
            this.props.appState.sort = sort;
        }
    }

    showChevron(sortType) {
        let sort = this.props.appState.sort;
        let sortDirection = this.props.appState.sortDirection;
        let sortDirectionStyle = "chevron-sort-direction-" + sortDirection;
        if (sortType === sort) {
            return <img src="/images/chevron.svg" alt={'Sort active: ' + sortType} className={ sortDirectionStyle } />
        }

        return <img src="/images/chevron-inactive.svg" alt="" className="chevron-inactive" />;
    }

    render() {
        return (
                <thead>
                    <tr>
                        <Desktop>
                            <th className="clickable center" onClick={ () => { this.setSort("rank") }}># { this.showChevron('rank') }</th>
                        </Desktop>
                        <Desktop>
                            <th className="no-click center favourite-table-header" title="Favorite coins always appear at the top, ignoring the selected sorting."/>
                        </Desktop>
                        <Desktop>
                            <th className="center">&nbsp;</th>
                        </Desktop>
                        <th className="clickable left header-name" onClick={ () => { this.setSort("name") }}>Coin { this.showChevron('name') }</th>
                        <th className="clickable right" onClick={ () => { this.setSort("price") }}>Price { this.showChevron('price') }</th>
                        <th className="clickable right" onClick={ () => { this.setSort("change") }}>Change 24h { this.showChevron('change') }</th>
                        <Desktop>
                            <th className="center">Charts (Past 24 hours)</th>
                        </Desktop>
                        <LargeDesktop>
                            <th className="clickable right" onClick={ () => { this.setSort("cap") }}>Market cap { this.showChevron('cap') }</th>
                        </LargeDesktop>
                        <LargeDesktop>
                            <th className="clickable right volume" onClick={ () => { this.setSort("volume") }}>Volume { this.showChevron('volume') }</th>
                        </LargeDesktop>
                    </tr>
                </thead>
        );
    }
}

export default TableHeader;



// WEBPACK FOOTER //
// ./src/CoinTableHeader.js